import { render, staticRenderFns } from "./adjust-volume.vue?vue&type=template&id=60451e28&scoped=true&"
import script from "./adjust-volume.vue?vue&type=script&lang=js&"
export * from "./adjust-volume.vue?vue&type=script&lang=js&"
import style0 from "./adjust-volume.vue?vue&type=style&index=0&id=60451e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60451e28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VSlider})
